<template>
	<div class="c-filter-newsroom-event--default" data-css="c-filter-newsroom-event" data-js-module="filter-newsroom-event">
	<div class="filter-newsroom-event__block">
		<div class="filter-newsroom-event__area" data-js-item="js-filter-newsroom-event-area">
			<FilterNewsroomEventTheme/>
			<FilterNewsroomEventTime/>
			<FilterNewsroomEventLocation/>
		</div>
		<FilterNewsroomEventActiveZone/>
	</div>
	<input type="hidden" ref="eventFilterString" @change="onFilterChange" data-js-item="js-filter-newsroom-event-filtersearchinput" name="filterSearchInput">
</div>
</template>


<script>

import FilterNewsroomEventTheme from "./FilterNewsroomEventTheme.vue";
import FilterNewsroomEventTime from "./FilterNewsroomEventTime.vue";
import FilterNewsroomEventLocation from "./FilterNewsroomEventLocation.vue";
import FilterNewsroomEventActiveZone from "./FilterNewsroomEventActiveZone.vue";
export default {
  	name: "FilterNewsroomEvent",
  	components: {
		FilterNewsroomEventTheme,
		FilterNewsroomEventTime,
		FilterNewsroomEventLocation,
		FilterNewsroomEventActiveZone
  	},
  	computed: {
	},
	data() {
		return {
		eventfilter: ''
		};
	},
	methods : {
		onFilterChange(){
			this.eventfilter = this.$refs.eventFilterString.value;
			const eventfilter = this.eventfilter === '' ? undefined : this.eventfilter;
			const thema = this.$store.getters.thema;
			const prios = undefined;
			this.$store.dispatch("getNewsroomInitData", {thema, prios, eventfilter});
		}
	}
};
</script>
